import React, { useEffect } from 'react';

function Toast({ message, type = 'info', onClose, duration = 3000 }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'info':
      default:
        return 'ℹ';
    }
  };

  return (
    <div className={`toast ${type}`}>
      <span style={{ fontSize: '20px', fontWeight: 'bold' }}>{getIcon()}</span>
      <span className="toast-message">{message}</span>
    </div>
  );
}

export default Toast;
